import type { SVGProps } from 'react'

export const BackpackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    viewBox="0 0 18 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.85718 15V15.625V20H14.1429V15.625V15H3.85718ZM5.46432 2.1875V3.75H7.39289V2.1875C7.39289 2.01562 7.53754 1.875 7.71432 1.875H10.2857C10.4625 1.875 10.6072 2.01562 10.6072 2.1875V3.75H12.5357V2.1875C12.5357 0.980469 11.5273 0 10.2857 0H7.71432C6.4728 0 5.46432 0.980469 5.46432 2.1875Z"
      fill="currentColor"
      opacity="0.4"
    />
    <path
      d="M0 8.75C0 5.98828 2.30223 3.75 5.14286 3.75H12.8571C15.6978 3.75 18 5.98828 18 8.75V17.5C18 18.8789 16.8469 20 15.4286 20H14.1429V15.625V13.125C14.1429 12.0898 13.279 11.25 12.2143 11.25H5.78571C4.72098 11.25 3.85714 12.0898 3.85714 13.125V15.625V20H2.57143C1.15313 20 0 18.8789 0 17.5V8.75ZM5.78571 6.875C5.43214 6.875 5.14286 7.15625 5.14286 7.5C5.14286 7.84375 5.43214 8.125 5.78571 8.125H12.2143C12.5679 8.125 12.8571 7.84375 12.8571 7.5C12.8571 7.15625 12.5679 6.875 12.2143 6.875H5.78571Z"
      fill="currentColor"
    />
  </svg>
)
